<template>
  <el-select v-model="value" placeholder="All" @update:modelValue="update">
    <el-option
      v-for="item in items"
      :key="item.key"
      :label="item.label"
      :value="item.key"
      :disabled="item.disabled"
    >
      {{ item.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { GroupType, GroupTypeLabel, GroupTypeLabels } from '@/api/types'
import { useUserStore } from '@/store/modules/user'

type GroupTypeEntry = {
  key: GroupType
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'GroupBySelect',
  props: {
    modelValue: {
      type: String,
      default: null
    },
    aggregationDates: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const userStore = useUserStore()
    const items = GroupTypeLabels.flatMap<GroupTypeEntry>(
      (item: GroupTypeLabel) => {
        if (
          (!userStore.rtb &&
            [GroupType.Feed, GroupType.SubId].includes(item.type_id)) ||
          !item.advert
        )
          return []

        return {
          key: item.type_id,
          label: item.label,
          disabled: props.aggregationDates && !item.aggregation
        }
      }
    )

    function update(newValue: string) {
      context.emit('update:modelValue', newValue)
    }

    return { update, items, value }
  }
})
</script>
